import { QueryObserverResult } from "@tanstack/react-query";
import { createContext, useContext } from "react";

import { Site } from "../api/Api";

interface SiteResponse {
  site: Site;
}
interface SiteContextType {
  site: SiteResponse | null;
  isLoadingSite: boolean;
  siteError: Error | null;
  refetchSite: () => Promise<QueryObserverResult<SiteResponse>>;
}

export const SiteContext = createContext<SiteContextType | null>(null);

export const useSiteContext = () => {
  return useContext(SiteContext);
};
